module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    config: {
        resourceConnected: false,
    },
}